// use lodash! https://lodash.com/docs/4.17.15
const fndryThemeInitWrapper = () => {
};

window.fndryThemeInitWrapper = fndryThemeInitWrapper;

// eslint-disable-next-line no-unused-expressions
document.body ? fndryThemeInitWrapper() : document.addEventListener( 'DOMContentLoaded', fndryThemeInitWrapper, false );
